module.exports = __webpack_public_path__ + "img/84.30d9764a.jpg";